// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const PrSyncModeSchema = z.enum(['AUTO_WEBHOOK','MANUAL_WEBHOOK','POLLING'] as const);

export type PrSyncModeType = `${z.infer<typeof PrSyncModeSchema>}`

export default PrSyncModeSchema;
